import { useEffect, useRef, useState } from "react";
import { PAISES_DOMICILIO, etiquetaPaisDomicilio, codigoCortoPaisDomicilio } from "../../constants/paisesDomicilio";

/** Banderas en SVG: el <select> nativo de Windows no pinta emoji de bandera. */
function Bandera({ code, size = 16 }) {
  const w = size;
  const h = Math.round(size * 0.75);
  const common = {
    width: w,
    height: h,
    viewBox: "0 0 20 15",
    style: { display: "block", flexShrink: 0, borderRadius: 2, overflow: "hidden" },
  };
  const c = String(code || "ES").toUpperCase();
  switch (c) {
    case "ES":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="20" height="15" fill="#c60b1e" />
          <rect y="3.75" width="20" height="7.5" fill="#ffc400" />
        </svg>
      );
    case "FR":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="6.67" height="15" fill="#002395" />
          <rect x="6.67" width="6.67" height="15" fill="#fff" />
          <rect x="13.33" width="6.67" height="15" fill="#ed2939" />
        </svg>
      );
    case "PT":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="20" height="15" fill="#ff0000" />
          <rect width="8" height="15" fill="#006600" />
        </svg>
      );
    case "DE":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="20" height="5" fill="#000" />
          <rect y="5" width="20" height="5" fill="#dd0000" />
          <rect y="10" width="20" height="5" fill="#ffce00" />
        </svg>
      );
    case "IT":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="6.67" height="15" fill="#009246" />
          <rect x="6.67" width="6.67" height="15" fill="#fff" />
          <rect x="13.33" width="6.67" height="15" fill="#ce2b37" />
        </svg>
      );
    case "GB":
      return (
        <svg {...common} viewBox="0 0 60 30" aria-hidden="true">
          <rect width="60" height="30" fill="#012169" />
          <path d="M0,0 60,30 M60,0 0,30" stroke="#fff" strokeWidth="10" />
          <path d="M0,0 60,30 M60,0 0,30" stroke="#c8102e" strokeWidth="6" />
          <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="16" />
          <path d="M30,0 v30 M0,15 h60" stroke="#c8102e" strokeWidth="10" />
        </svg>
      );
    case "BE":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="6.67" height="15" fill="#000" />
          <rect x="6.67" width="6.67" height="15" fill="#fdda24" />
          <rect x="13.33" width="6.67" height="15" fill="#ef3340" />
        </svg>
      );
    case "NL":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="20" height="5" fill="#ae1c28" />
          <rect y="5" width="20" height="5" fill="#fff" />
          <rect y="10" width="20" height="5" fill="#21468b" />
        </svg>
      );
    case "CH":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="20" height="15" fill="#ff0000" />
          <rect x="8.5" y="3" width="3" height="9" fill="#fff" />
          <rect x="5.5" y="6" width="9" height="3" fill="#fff" />
        </svg>
      );
    case "AD":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="6.67" height="15" fill="#10069f" />
          <rect x="6.67" width="6.67" height="15" fill="#fedd00" />
          <rect x="13.33" width="6.67" height="15" fill="#d50032" />
        </svg>
      );
    case "MA":
      return (
        <svg {...common} aria-hidden="true">
          <rect width="20" height="15" fill="#c1272d" />
          <polygon points="10,3.4 11.5,7.8 16.2,7.8 12.4,10.5 13.8,14.8 10,12.1 6.2,14.8 7.6,10.5 3.8,7.8 8.5,7.8" fill="none" stroke="#006233" strokeWidth="1.1" />
        </svg>
      );
    default:
      return (
        <svg {...common} aria-hidden="true">
          <rect width="20" height="15" fill="#64748b" />
          <circle cx="10" cy="7.5" r="4.2" fill="none" stroke="#e2e8f0" strokeWidth="1.2" />
          <path d="M10 3.3 v8.4 M5.8 7.5 h8.4" stroke="#e2e8f0" strokeWidth="1.1" />
        </svg>
      );
  }
}

export default function SelectPaisDomicilio({
  value,
  onChange,
  disabled = false,
  inpSt,
  isDark,
}) {
  const [abierto, setAbierto] = useState(false);
  const rootRef = useRef(null);
  const code = value || "ES";
  const actual = PAISES_DOMICILIO.find((p) => p.code === code) || PAISES_DOMICILIO[0];

  useEffect(() => {
    if (!abierto) return undefined;
    const onDoc = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setAbierto(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setAbierto(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [abierto]);

  return (
    <div ref={rootRef} style={{ position: "relative", minWidth: 0 }}>
      <button
        type="button"
        disabled={disabled}
        title={actual.nombre}
        aria-haspopup="listbox"
        aria-expanded={abierto}
        onClick={() => { if (!disabled) setAbierto((v) => !v); }}
        style={{
          ...inpSt,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 5,
          padding: "8px 4px",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.6 : 1,
          fontWeight: 800,
          letterSpacing: "0.04em",
          textAlign: "center",
        }}
      >
        <span>{codigoCortoPaisDomicilio(actual.code)}</span>
      </button>
      {abierto && (
        <div
          role="listbox"
          style={{
            position: "absolute",
            right: 0,
            bottom: "calc(100% + 4px)",
            zIndex: 40,
            minWidth: 200,
            maxHeight: 260,
            overflowY: "auto",
            background: inpSt?.background || (isDark ? "#111827" : "#fff"),
            border: inpSt?.border || `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,
            borderRadius: 8,
            boxShadow: "0 10px 28px rgba(0,0,0,0.35)",
            padding: 4,
          }}
        >
          {PAISES_DOMICILIO.map((p) => {
            const sel = p.code === actual.code;
            return (
              <button
                key={p.code}
                type="button"
                role="option"
                aria-selected={sel}
                title={etiquetaPaisDomicilio(p.code)}
                onClick={() => {
                  onChange(p.code);
                  setAbierto(false);
                }}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "7px 8px",
                  border: "none",
                  borderRadius: 6,
                  background: sel ? (isDark ? "rgba(59,130,246,0.22)" : "rgba(37,99,235,0.12)") : "transparent",
                  color: inpSt?.color || "inherit",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  fontSize: 12,
                  textAlign: "left",
                }}
              >
                <Bandera code={p.code} />
                <span style={{ fontWeight: 700 }}>
                  {codigoCortoPaisDomicilio(p.code)} - {p.nombre}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
